import moment from '@helpers/moment';

export const formatDateWithLocale = (date, language) => {
  const localeDate = moment(date * 1000).locale(language);
  // if (language === "en-ca") {
  //  return localeDate.format("MMMM DD") + ", " + localeDate.format("YYYY");
  // } else if (language === "fr-ca") {
  //  return localeDate.format("DD MMMM YYYY");
  // }
  return moment(date).locale(language).format('DD MMM YYYY');
};
